import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import CloseIcon from '@mui/icons-material/Close';

const CalcDescriptionModal = ({show, onHide, index}) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if(copied){
      setTimeout(() => {
        setCopied(false)
      }, 2000)
    }
  }, [copied]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size='lg'
      centered
    >
      <Modal.Header className="d-block" style={{
        fontSize: 16,
        padding: '25px 32px',
        borderBottom: index?.calcDescr ? '1px solid #dee2e6' : 'none',
        position: 'relative'
      }}>
        <h3 className="mb-2" style={{ fontWeight: 600 }}>Полное наименование:</h3>
        <p>{index?.fullName || index?.name}</p>
        <button
          onClick={onHide}
          style={{
            position: 'absolute',
            right: -42,
            top: 0,
            backgroundColor: '#888889',
            borderRadius: '50%',
            border: 'none',
            width: 32,
            height: 32,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <CloseIcon style={{ color: 'white', fontSize: 18 }}/>
        </button>
      </Modal.Header>
      {index?.calcDescr && <Modal.Body style={{ padding: '24px 32px' }}>
        <h3 className="mb-2" style={{ fontWeight: 600 }}>Методика:</h3>
        <p>{index?.calcDescr}</p>
      </Modal.Body>}
      <Modal.Footer style={{
        borderTop: 'none',
        padding: '0 32px 24px 32px'
      }}>
        <Button onClick={onHide} variant="outline-primary">Ок</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CalcDescriptionModal;
